import { create } from "zustand";
import { Backend } from "../url";

interface FilterData {
  dropdowns: Record<
    string,
    {
      type: string;
      category: string;
      choices: { value: string; label: string }[];
    }
  >;
  sliders: Record<
    string,
    {
      type: string;
      category: string;
      range: { min: number; max: number };
    }
  >;
}

interface FilterState {
  filterData: FilterData | null;
  lastUpdated: number | null;
  isLoading: boolean;
  error: string | null;
  fetchFilterData: () => Promise<void>;
}

const useFilterStore = create<FilterState>((set, get) => ({
  filterData: null,
  lastUpdated: null,
  isLoading: false,
  error: null,

  fetchFilterData: async () => {
    if (get().isLoading) return;

    set({ isLoading: true, error: null });
    try {
      const response = await fetch(`${Backend}/search/options/`);
      if (!response.ok) {
        throw new Error(`API Request Fail: ${response.status}`);
      }
      const data = await response.json();
      set({
        filterData: data.data,
        lastUpdated: Date.now(),
        isLoading: false,
      });
    } catch (error) {
      console.error("Data load error:", error);
      set({
        error: error instanceof Error ? error.message : "error?",
        isLoading: false,
      });
    }
  },
}));

export default useFilterStore;
